import React, { useEffect, useState } from "react"
import CCModal2025 from "../../../../../components/ccModal2025"
import FormControlCustom from "../../../../../components/formControlCustom"
import { I18n } from "react-redux-i18n"
import { CCLiteCommonFunc, formatCurrencyHasSymbol } from "../../../../../utils/commonFunctions"
import { FLEET_BILLING_MODE } from "../../../utils/constants"

const TopupPopup = ({
  onClose,
  billingUsage,
  handleTopup,
  onOpenBillingUrl,
  isMakePayment,
  gsnCreditBalance
}) => {
  const [isSubmmitted, setIsSubmmitted] = useState(false)
  const [formState, setFormState] = useState({})
  const [previewData, setPreviewData] = useState({})
  const [step, setStep] = useState(1)
  const [isShowStep_1, setshowstep_1] = useState(false)

  const [validState, setValidState] = useState({});

  useEffect(() => {
    if(isMakePayment) {
      setFormState((prevState) => ({
        ...prevState,
        amount: gsnCreditBalance
      }))
    }
  }, [isMakePayment, gsnCreditBalance])

  useEffect(() => {
    if( billingUsage?.paymentMethods[0]?.paymentId && !formState?.card) {
      setFormState((prevState) => ({
        ...prevState,
        card: billingUsage?.paymentMethods[0]?.paymentId
      }))
    }
  }, [billingUsage?.paymentMethods[0]?.paymentId])

  const ValidatorCallback = (id, valid) => {
    setValidState((prevState) => {
      const newValidState = { ...prevState };
      if (newValidState && newValidState[id] !== valid) {
        newValidState[id] = valid;
        return newValidState;
      }
      return prevState;
    });
  };

  const handleSelectPaymentMethod = (value) => {
    setFormState((prevState) => ({
      ...prevState,
      card: value
    }))
  }

  const renderStep_1 = () => {

    const getOptionPaymentMethod = () => {
      let optionMethods = [{
        value: '',
        label: I18n.t('billingUsage.addNewPaymentMethod')
      }]
      const cardMethods = billingUsage?.paymentMethods?.map((paymentMethod) => ({
        value: paymentMethod?.paymentId,
        label: paymentMethod?.email ? 
          paymentMethod?.email : 
            paymentMethod?.cardType ? `${paymentMethod?.cardType?.toUpperCase()} *${paymentMethod?.last4}` : 
            'Stripe'
      })) || []
      // if(billingUsage?.billingMode === FLEET_BILLING_MODE.invoice) {
      //   optionMethods = [...optionMethods, {value: 'ADD_NEW_CARD', label: I18n.t('billingUsage.addNewPaymentMethod')}, ...cardMethods]
      // } else {
      // }
      optionMethods = [...optionMethods, ...cardMethods]
      return optionMethods
    }

    return (
      <>
        <FormControlCustom
          validatorCallback={ValidatorCallback}
          valid={validState}
          value={formState.amount}
          isSubmitted={isSubmmitted}
          handleChange={(value) => {
            setFormState((prevState) => ({
              ...prevState,
              amount: value
            }))
          }}
          field={{
            title: I18n.t('billingUsage.AddBalance'),
            key: 'amount',
            type: 'number',
            placeholder: '0',
            textGRPrepend: billingUsage?.currencyISO,
            rules: {
              required: '',
            },
            disabled: isMakePayment,
          }}
        />
        <FormControlCustom
          validatorCallback={ValidatorCallback}
          valid={validState}
          value={formState.card}
          isSubmitted={isSubmmitted}
          handleChange={(value) => {
            handleSelectPaymentMethod(value)
          }}
          field={{
            title: I18n.t('cue.Payment_Method'),
            key: 'card',
            type: 'select',
            option: getOptionPaymentMethod(),
            // rules: {
            //   required: '',
            // },
          }}
        />
      </>
    )
  }

  const renderStep_2 = () => {
    const paymentMethod = billingUsage?.paymentMethods?.find((paymentMethod) => paymentMethod?.paymentId === formState?.card)
    return (
      <div>
        <p className="d-flex justify-content-between" style={{ borderBottom: '1px solid #363A44', color: '#A1A1AA', padding: '5px 0' }}>
          <span>{I18n.t('thirdPartySettings.description')}</span>
          <span>{I18n.t('driver.Amount')}</span>
        </p>
        <p className="d-flex justify-content-between" style={{ borderBottom: '1px solid #363A44', padding: '5px 0', fontSize: '12px', fontWeight: '500' }}>
          <span>{I18n.t('billingUsage.usageCredit')}</span>
          <span>{
            formatCurrencyHasSymbol(
              formState.amount || 0,
              billingUsage?.currencyISO
            )
          }</span>
        </p>
        {
          previewData?.tax > 0 && (
            <p className="d-flex justify-content-between" style={{ borderBottom: '1px solid #363A44', padding: '5px 0', fontSize: '12px', fontWeight: '500' }}>
              <span>{I18n.t('billingUsage.Tax')}</span>
              <span>{
                formatCurrencyHasSymbol(
                  previewData?.tax || 0,
                  billingUsage?.currencyISO
                )
              }</span>
            </p>
          )
        }
        <p className="d-flex justify-content-between" style={{ borderBottom: '1px solid #363A44', padding: '5px 0', fontSize: '12px', fontWeight: '500' }}>
          <span>{I18n.t('billingUsage.estTotal')}</span>
          <span>{
            formatCurrencyHasSymbol(
              previewData?.amountDue || 0,
              billingUsage?.currencyISO
            )
          }</span>
        </p>
        {
          paymentMethod && (
            <p className="mt-4">
              <span>{I18n.t('cue.Payment_Method')}</span>
              <div className="d-flex align-items-center mt-2" style={{ backgroundColor: '#24272E', padding: '15px', borderRadius: '5px', color: '#98A2B3', fontSize: '16px', fontWeight: '500' }}>
                <div id="creditcard" style={{ width: '40px', height: '25px', backgroundSize: 'contain', backgroundRepeat: 'no-repeat' }} className={`${paymentMethod?.cardType ? paymentMethod?.cardType : 'stripe'} mr-3`}>
                </div>
                <div className="d-flex flex-column">
                  <span style={{ fontSize: '16px', lineHeight: '1' }}>****{paymentMethod?.last4}</span>
                  <span style={{ fontSize: '12px' }}>{paymentMethod?.email ? paymentMethod?.email : paymentMethod?.expMonth && paymentMethod?.expireYear ? `${I18n.t('billingUsage.expires')} ${paymentMethod?.expMonth}/${paymentMethod?.expireYear}` : 'Stripe'}</span>
                </div>
              </div>
            </p>
          )
        }
        <p className="mt-3" style={{ fontSize: '14px', fontWeight: '500', color: '#98A2B3' }}>
          By continuing you agree to our <a style={{ color: '#04BE76' }} href="https://www.goodjourney.io/en/terms" target="_blank" rel="noopener noreferrer">service credit terms</a>. Paid credits are non-refundable and expire one year from purchase date.
        </p>
      </div>
    )
  }

  const handlePreviewTopup = async () => {
    const result = await handleTopup({
      amount: formState.amount,
      paymentMethodId: formState.card,
      preview: true,
      makePayment: isMakePayment
    })
    if (result?.returnCode === 200) {
      setPreviewData({
        ...result?.response,
        tax: result?.response?.items?.find((item) => item?.lockup?.startsWith('tax'))?.amount || 0,
      })
      setStep(2)
      return;
    }
  }
  const onSubmit = () => {
    if (step === 1) {
      setIsSubmmitted(true)
      if (!CCLiteCommonFunc.isFormValid(validState)) {
        return;
      }
      handlePreviewTopup();
      setStep(2)
      return;
    }
    handleTopup({
      amount: formState.amount,
      paymentMethodId: formState.card,
      invoiceId: previewData?.invoiceId,
      makePayment: isMakePayment
    })
  }

  const handleCloseFooter = () => {
    if (step === 2) {
      setStep(1);
      return;
    }
    setFormState({})
    setValidState({})
    setIsSubmmitted(false)
    setStep(1)
    onClose()
  }

  return (
    <>
      <CCModal2025
        isShow={true}
        onClose={onClose}
        title={I18n.t(`${step === 2 ? 'billingUsage.confirm' : 'billingUsage.AddBalance'}`)}
        btnCloseText={I18n.t(`${step === 2 ? 'billingUsage.Back' : 'billingUsage.cancel'}`)}
        btnSubmitText={I18n.t(`${step === 2 ? 'billingUsage.confirm' : 'billingUsage.continue'}`)}
        onCloseFooter={handleCloseFooter}
        onSubmit={onSubmit}
      >
        {
          step === 2 ? (
            renderStep_2()
          ) : (
            renderStep_1()
          )
        }
      </CCModal2025>
    </>
  )
}

export default TopupPopup;